import { schemas } from '@repo/contracts'
import { parseDataOfType } from '@/common/parseDataType'
import { apiErrorHandler } from '../errorHandler'
import type { z } from 'zod'

const ActivityReportResponseSchema = schemas.apihttp_ActivityReportResponse.describe('ActivityReportResponse')
export type ActivityReport = z.infer<typeof ActivityReportResponseSchema>

export async function getActivityReport(): Promise<ActivityReport> {
  const res = await fetch(`${window.location.origin}/api/sysadmin/activity`, {
    method: 'GET',
    credentials: 'same-origin'
  })
  await apiErrorHandler(res)
  return parseDataOfType(await res.json(), ActivityReportResponseSchema)
}
